import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as bie from "react-bootstrap";
import { viewImage } from '../../CommonUtils/viewImage';
import { FaCheck, FaHome, FaTimes } from 'react-icons/fa';

export default function AffiliationPrint() {
    const [currentStep, setCurrentStep] = useState(0);
    const [statusObj, setStatusObj] = useState({});
    const [allDone, setAllDone] = useState(false);
    const acYear = sessionStorage.getItem('ac_year');

    const fieldToStepIndex = {
        affl_ffca_member_details: 0,
        affl_ffca_committe_photos: 1,
        affl_ffca_plinth_area: 2,
        affl_ffca_faculty_availability: 3,
        affl_ffca_lab_availability_remarks: 4,
        affl_ffca_document_remarks: 5,
        affl_oamdc_ffca_remarks: 6,
        affl_ffca_coll_details_app: 7,
        affl_ffca_coll_clsroom_uploads: 8,
        affl_ffca_coll_lab_uploads: 9,
        affl_ffca_coll_building_uploads: 10,
        affl_ffca_coll_library_uploads: 11,
        affl_ffca_coll_playgrnd_uploads: 12,
        affl_ffca_coll_parkingarea_uploads: 13,
        affl_inspection_data_details: 14,
        affl_ffca_deficiencies: 15,
        affl_final_recomm: 16
    };

    const stepTitles = [
        "Membership Section",
        "Committee Photos",
        "Plinth Area",
        "Faculty Availability",
        "Lab Availability ",
        "Document Remarks",
        "OAMDC Remarks",
        "College Details",
        "Classroom Uploads",
        "Lab Uploads",
        "Building Uploads",
        "Library Uploads",
        "Playground Uploads",
        "Parking Area Uploads",
        "Registered Deed Details",
        "FFCA Deficiencies",
        "Feedback/Final Submission"
    ];

    function computeCurrentStep(status) {
        for (const [field, idx] of Object.entries(fieldToStepIndex)) {
            if (status[field] !== 'Done') {
                return idx + 1;
            }
        }
        return stepTitles.length;
    }

    function isAllDone(status) {
        return Object.keys(fieldToStepIndex).every(
            field => status[field] === 'Done'
        );
    }

    useEffect(() => {
        GetData();
    }, []);
    function GetData() {
        const url = `${config.url.API_URL}getFfcaSectionStatus`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const rawObj = res.data.getFfcaSectionStatus[0];

                // Normalize keys to remove `_status`
                const normalizedObj = {};
                for (const key in rawObj) {
                    if (key.endsWith('_status')) {
                        const baseKey = key.replace('_status', '');
                        normalizedObj[baseKey] = rawObj[key];
                    } else {
                        normalizedObj[key] = rawObj[key];
                    }
                }

                setStatusObj(normalizedObj);
                setCurrentStep(computeCurrentStep(normalizedObj));
                setAllDone(isAllDone(normalizedObj));

            } else {
                setStatusObj({});
                setCurrentStep(0);
                setAllDone(false);

            }
        });
    }
    const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');



    function FfcaPdf() {
        const url = `${config.url.API_URL}getFfcaPdf/${userid}/${acYear}`;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status) {
                viewImage(res.data.path);
            } else {
                console.log("No Data Found");
            }
        });
    }

    return (
        <>
            <div className="inner-herbpage-service-title1">
                <bie.Row>

                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className='mb-2'>

                        {/* <h5 className="mb-0">College Status, AcYear {acYear}</h5> */}
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>

                        <button className="breadcrumb-item">
                            <a href="/dashboard" className="affl-dash">
                                <FaHome size={30} />
                            </a>
                        </button>
                    </bie.Col>
                </bie.Row>
            </div>

            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
                    <h1 className="mb-0">
                        College Name: <span>{statusObj.inst_name}</span>
                    </h1>
                    <h1 className="mb-0 ms-4">
                        College Code: <span>{statusObj.coll_code}</span>
                    </h1>
                </div>

                <bie.Container fluid className="pt-5 d-flex justify-content-center">
                    <bie.Row>
                        <bie.Col md={12} className="px-4">
                            <div className="vertical-stepper">
                                {stepTitles.map((title, i) => {
                                    const stepIndex = i + 1;
                                    const fieldName = Object.keys(fieldToStepIndex).find(key => fieldToStepIndex[key] === i);
                                    const val = statusObj[fieldName];
                                    const isDone = val === 'Done';  // ✅ boolean now
                                    const isActive = stepIndex === currentStep;

                                    return (
                                        <div key={fieldName} className="stepper-step d-flex mb-4">
                                            <div className="icon-column d-flex flex-column align-items-center">
                                                <div className={`step-circle ${isDone ? 'completed' : isActive ? 'active' : 'pending'}`}>
                                                    {isDone ? <FaCheck /> : stepIndex}
                                                </div>
                                                {i < stepTitles.length - 1 && (
                                                    <div className={`step-line ${stepIndex < currentStep ? 'line-completed' : ''}`}></div>
                                                )}
                                            </div>
                                            <button
                                                type="button"
                                                className="step-text ps-3"
                                                onClick={() => setCurrentStep(stepIndex)}
                                            >
                                                <div className={`step-label ${isDone ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}>
                                                    {title}
                                                </div>
                                                <div className="step-status mt-1">
                                                    <bie.Badge bg={isDone ? "success" : "danger"}>
                                                        {isDone
                                                            ? (<><FaCheck className="me-1" /> Done</>)
                                                            : (<><FaTimes className="me-1" /> Not Done</>)
                                                        }
                                                    </bie.Badge>
                                                </div>
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </bie.Col>
                    </bie.Row>
                </bie.Container>
                {allDone && (
                    <center>
                        <button
                            type="button"
                            className="btn btn-sm affl-print me-2"
                            onClick={() => FfcaPdf()}
                        >
                            Print PDF
                        </button>
                    </center>
                )}
            </bie.Container>
        </>
    );
}
